<template>
  <Drawer
          title="重新预约"
          v-model="_value"
          width="100"
          :mask-closable="false"
          @on-visible-change="visibleChange"
  >
    <Form :model="installOrder">
      <Row>
        <Col span="12">
          <FormItem label="车牌号：" label-position="top">
            {{installOrder.vehicleInfo != null ? installOrder.vehicleInfo.registrationNum :installOrder.tempVehicleInfo.registrationNum}}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="车架号：" label-position="top">
            <label>{{installOrder.vehicleInfo != null ? installOrder.vehicleInfo.vin :installOrder.tempVehicleInfo.vin}}</label>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="预约时间" label-position="top">
            <DatePicker v-model="installOrder.actualDatetime" type="datetime" placeholder="预约时间" style="display: block" placement="bottom-end" :options="options1"></DatePicker>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="预约地点" label-position="top">
            <Input class="field" v-model="installOrder.actualPlace" placeholder="预约地点">
            </Input>
          </FormItem>
        </Col>
      </Row>
      <FormItem v-if="installOrder.step != null" label="联系结果" label-position="top">
        <Input type="textarea" v-model="installOrder.step.result" :rows="2" placeholder="联系结果" />
      </FormItem>
    </Form>
    <div class="demo-drawer-footer">
      <Button style="margin-right: 8px" @click="_value = false">取消</Button>
      <Button type="primary" @click="Reschedule">提交</Button>
    </div>
  </Drawer>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  import {
    Cell,
    CellGroup,
    Field,
    Row,
    Col,
    Button,
    Dialog,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Picker,
    Popup,
    Divider,
    Collapse,
    CollapseItem,
    DatetimePicker,
    Tag,
    DropdownMenu,
    DropdownItem,
    Sticky,
    Icon,
    Search,
    PullRefresh,
    List,
    Loading,
    Toast,
    Uploader,
    Overlay,
    NumberKeyboard,
    Tab, Tabs
  } from 'vant'

  Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Tab).use(Tabs)
          .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay).use(NumberKeyboard)
          .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

  export default {
    name: 'rescheduleinstallermodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        //设置日期限制
        options1: {
          disabledDate (date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        //订单信息
        installOrder: {
          id: null,
          totalAmount: '',
          serviceDatetime: null,
          businessUserId: null,
          businessType: 1,
          multiDevices: false,
          qghyptOption: 0,
          clientInfoId: null,
          remark: null,
          billType: 1,
          vehicleInfoGroupId: null,
          vehicleInfoGroupId: null,
          positioningDevice: null,
          positioningDeviceId: null,
          positioningDeviceInfos: null,
          positioningDeviceInfosCount: 0,
          vehicleInfoId: null,
          isfree: 1,
          reInstall: false,
          tempVehicleInfo: {
            customName: null,
            registrationNum: null,
            registrationColor: null,
            vin: null,
            bodyColor: null,
            vehicleType: {
              name: null
            },
            vehicleBrand: {
              name: null
            },
            engineNum: null,
            vehicleLicenseNum: null,
            unladenMass: null,
            approvedLoad: null,
            vehicleOwnerInfoId: null,
            servicePassword: null,
            vehicleLicenseDistributeDatetime: null,
            vehicleLicenseReigsterDatetime: null,
            remark: null,
            certificateNum: null,
            certificateDistributeDatetime: null,
            vehicleModel: {
              name: null
            },
            chassisModel: null,
            chassisId: null,
            chassisCertificateNum: null,
            engineModel: null,
            energyType: null,
            displacement: null,
            power: null,
            energyUsage: null,
            emissionStandard: null,
            manufacturer: null,
            outlineSizeLong: null,
            outlineSizeWidth: null,
            outlineSizeHeight: null,
            boxSizeLong: null,
            boxSizeWidth: null,
            boxSizeHeight: null,
            springPieceCount: null,
            tyreCount: null,
            tyreSpec: null,
            wheelSpanFront: null,
            wheelSpanBack: null,
            wheelBase: null,
            axisLoad: null,
            axisCount: null,
            turnType: null,
            totalMass: null,
            approvedLoadCoefficient: null,
            towMax: null,
            saddleMax: null,
            cabPeopleCount: null,
            mannedCount: null,
            speedMax: null,
            productionDatetime: null,
            certificateRemark: null,
            vehicleLicensePictureId: null,
            certificatePictureId: null,
            vehicleSrcLicensePicture1Id: null,
            vehicleSrcLicensePicture2Id: null,
            vehicleBodyPictureId: null,
            vehicleUse: null,
            attention: false,
            salesChannelId: null,
            mliftainsuranceChannelId: null,
            mliftainsurancechannelDatetime: null,
            tiinsuranceChannelId: null,
            tiinsurancechannelDatetime: null,
            insured: null,
          },
          installer:null,
          installerId:null,
          installerlsit:null,
          bookingDatetime:null,
          bookingPlace:null,
          actualDatetime:null,
          actualPlace:null,
          stepId:null,
          step:{
            orderId:null,
            state:null,
            lastState:null,
            userId:null,
            user:null,
            result:null,
          },
        },

      }
    },
    methods: {
      ...mapActions([
        'InstallOrderServ_ChangeInstaller',
        'UserServ_GetAllUsers',
        'InstallOrderServ_GetDetail'
      ]),
      Reschedule(){
        store.dispatch('InstallOrderServ_Reschedule',{
          params:this.installOrder,
          urlparams:null
        }).then(()=>{
          console.log(store.getters.get_InstallOrder_RescheduleResult)
          this.$emit('on-success')
        }).catch(err => {
          this.$Message.error(err)
        })
        this._value = false
      },
      visibleChange(){
        store.dispatch('InstallOrderServ_GetDetail', {
          params: {id:this._initValue},
          urlparams: null
        }).then(() => {
          this.installOrder = store.getters.get_InstallOrder_GetDetailResult
        }).catch(err => {
          this.$Message.error(err)
        })
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
      })
    }
  }
</script>
